import { render, staticRenderFns } from "./DeliveryStadium.vue?vue&type=template&id=4312c5d8&scoped=true"
import script from "./DeliveryStadium.vue?vue&type=script&lang=ts"
export * from "./DeliveryStadium.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryStadium.vue?vue&type=style&index=0&id=4312c5d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4312c5d8",
  null
  
)

export default component.exports